<template>
    <div class="header">
        <div :class="{'hide':this.allowToShow(['home','contact'])}" class="user-pic" id="sidePanelBtn" v-on:click="openSideBar">
            <img :src="url" />
        </div>
        <div :class="{'hide':this.allowToShow(['home','profile','contact','login'])}" class="status-bar">
            <router-link to="/home">
            {{$store.state.status}}
            </router-link>
        </div>
        <!-- <div class="new-message-indicator"></div> -->
        <div :class="{'hide':this.allowToShow(['chatPage','profile','searchPage'])}" class="backward-button unSelectable" @click='goBack'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
        </div>
        <div :class="{'hide':this.allowToShow(['chatPage','searchPage'])}" class="chat-title unSelectable">{{this.$store.state.nowTitle}}</div>
        <div :class="{'hide':this.allowToShow(['home','contact'])}" class="topButton unSelectable" @click='initSearch'>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 22 22"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
        </div>
        <div :class="{'hide':this.allowToShow(['home'])}" class="bottomButton unSelectable" @click='refresh'>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 26 26"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
        </div>
        <div :class="{'hide':this.allowToShow(['searchPage'])}" class="bottomButton unSelectable" @click='createGroup'>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 22 22"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
        </div>
        <div :class="{'hide':this.allowToShow(['chatPage'])}" class="topButton unSelectable" @click='groupProfile'>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 22 22"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
        </div>
    </div>
</template>

<style>
    .header {
        z-index: 1;
        position: fixed;
        top: 0px;
        left:0;
        height:64px;
        width: 100vw;
        background-color:#25a23b;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.4),0 0 ;
        display: flex;
        flex-direction: row;
        padding-left:12px;
        padding-right:12px;
        align-items: center;
    }

    .header .user-pic {
        order: 1;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #8bc34a;
        margin-right: 12px;
        /* box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1),1px 1px 1px rgba(0, 0, 0, 0.1); */
        font-size:28px;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
    }

    .header .user-pic img {
        max-height:100%; 
        max-width:100%;
        object-fit: contain;
    }

    .header .status-bar {
        order: 2;
        font-size: 24px;
        font-weight: 600;
        margin-right: 12px;
    }

    .header .new-message-indicator {
        order:3;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #F2C03B;
        overflow: hidden;
        animation-name: indicator-breathe;
        animation-duration: 0.8s;
        animation-iteration-count: infinite;
        animation-direction: alternate-reverse;
    }

    .header .backward-button {
        order:1;
        color: #ffffff7a;
        overflow: hidden;
        line-height: 36px;
        font-size: 36px;
        font-weight: 600;
        margin-right: 12px;
        /* animation-name: reveal-title;
        animation-duration: 0.6s; */
        cursor: pointer;
    }

    .header .chat-title {
        order:5;
        overflow: hidden;
        font-size: 24px;
    }

    .header .topButton {
        position: fixed;
        right: 0;
        margin-right: 10px;
    }

    .header .topButton svg {
        cursor: pointer;
    }

    .header .bottomButton {
        position:fixed;
        right: 12px;
        bottom: 16px;
        border-radius:50%;
        height:38px;
        width:38px;
        /* background-color: #8bc34a; */
    }

    .header .bottomButton svg {
        cursor: pointer;
        margin-top: 0;
        animation-name: reveal-refresh;
        animation-duration: 1s;
        transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
    }

    @keyframes indicator-breathe {
		from {opacity: 1;}
		to {opacity: 0;}
	}

    @keyframes reveal-title {
		from {margin-left: 32px;}
		to {margin-left: 0;}
	}

    @keyframes reveal-refresh {
		from {margin-top: 50px;}
		to {margin-top: 0;}
	}
    
</style>

<script>

export default {
    name:'headBar',
    props:['url'],
    methods: {
        openSideBar: function () {
            if(this.$store.state.userStatus==='loggedin'){
                this.$store.state.sideBarOpen=true;
            }
        },
        allowToShow:function(array){
            if(array.indexOf(this.atPageName)!==-1){
                return false
            }else{
                return true
            }
        },
        goBack:function(){
            switch(this.$route.name){
                case 'profile':
                    // this.$router.push({path:`/contact`,replace:true});
                    this.$router.go(-1);
                    break; 
                case 'chatPage':
                    // this.$router.push({path:`/home`,replace:true});
                    this.$router.go(-1);
                    break;      
                default:
                    this.$router.go(-1);
            }
        },
        initSearch:function(){
            // console.log('initSearch');
            this.$router.push({path:`/searchPage`,replace:true});
        },
        refresh:function(){
            // console.log('refresh');
            this.$socket.emit('clientAuth',{id:this.$store.state.userMail,password:this.$store.state.userPasswd});
        },
        createGroup:function(){
            this.$store.state.searchPageModalOpen=true;
            this.$store.state.showSearchPageCreateGroup=true;
            // console.log('createGroup');
        },
        groupProfile:function(){
            // console.log('groupProfile');
            this.$store.state.chatPageModalOpen=true;
        }
    },
    computed:{
        atPageName(){
            return this.$route.name
        }
    }
}
</script>

